// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e6df85ad","71":"890cd004"}[chunkId] + ".chunk.js";
};